import { createSlice } from '@reduxjs/toolkit';

const MODE_KEY = "themeMode";

// Remembered choice from the last visit; dark by default
const readSavedMode = () => {
  try {
    const saved = localStorage.getItem(MODE_KEY);
    return saved === "light" || saved === "dark" ? saved : "dark";
  } catch {
    return "dark";
  }
};

const initialState = {
  mode: readSavedMode(),
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
      try {
        localStorage.setItem(MODE_KEY, state.mode);
      } catch {
        // storage unavailable (private mode): the toggle still works for this visit
      }
    },
  },
});

export const { setMode } = globalSlice.actions;

export default globalSlice.reducer;
